module.exports = __webpack_public_path__ + "static/3-ed1227268f1fc4bf70e8ca0584d8bcce.png";